<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card stacked-form">
                    <div class="card-header">
                        <h4 class="card-title float-left" v-if="category.id"> Изменить категорию</h4>
                        <h4 class="card-title float-left" v-else> Добавить категорию</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="name">Название <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="name" v-model="category.name"
                                        :class="{invalid : $v.category.name.$error}"
                                        @blur="$v.category.name.$touch()">
                                    <div class="red" v-if="$v.category.name.$error">Пожалуйста, введите название</div>
                                </div>
                                <div class="form-group">
                                    <label for="name">Название(RU) <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="nameRu" v-model="category.nameRu"
                                           :class="{invalid : $v.category.nameRu.$error}"
                                           @blur="$v.category.nameRu.$touch()">
                                    <div class="red" v-if="$v.category.nameRu.$error">Пожалуйста, введите название</div>
                                </div>
                                <div class="form-group">
                                    <label for="sortOrder">Порядок сортировки</label>
                                    <input type="text" class="form-control" id="sortOrder" v-model="category.sortOrder">
                                </div>
                                <div class="form-group">
                                    <label>Родитель</label>
                                    <v-select v-model="category.parent" label="name"
                                                      :options="parents"
                                                      :filterable="false"
                                                      @search="onParentSearch"
                                                      @search:focus="onParentFocus()"></v-select>
                                </div>
                                <div class="form-group">
                                    <label>Изображение</label>
                                    <vue-dropzone id="categoryPhotoDropZone"
                                                          ref="categoryPhotoDropZone"
                                                          :options="dropZoneOptions"
                                                          @vdropzone-upload-progress="onDropZoneProgress"
                                                          @vdropzone-success="onDropZoneSuccess"
                                                          @vdropzone-error="onDropZoneError"
                                                          @vdropzone-removed-file="onDropZoneRemove">
                                            </vue-dropzone>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label>Дополнительные параметры</label>
                                        </div>
                                        <div class="col-md-12">
                                            <draggable v-model="category.parameters" :options="{draggable:'.item'}">
                                                <div v-for="(variation, index) in category.parameters" :key="variation.index" class="item">
                                                     <div class="btn-remove" @click="removeVariation(index)">
                                                         <i class="fa fa-close"></i>
                                                     </div>
                                                    <div class="row">
                                                        <div class="col-12 col-md-6 widget">
                                                            <select class="form-control" v-model="variation.type" :style="{color: (variation.type==='' ? '#CCCCCC' : '#000000')}"
                                                                @change="variation.defaultValue = ''">
                                                                <option value="" style="color: #CCCCCC">Выберите тип</option>
                                                                <option value="text" style="color: #000000">Текст</option>
                                                                <option value="integer" style="color: #000000">Целое число</option>
                                                                <option value="decimal" style="color: #000000">Десятичный число</option>
                                                                <option value="list" style="color: #000000">Список</option>
                                                                <option value="multiselect" style="color: #000000">Мултиселект</option>
-                                                               <option value="multicheck" style="color: #000000">Мултичек</option>
                                                                <option value="date" style="color: #000000">Дата</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-12 col-md-6 widget">
                                                            <input type="text" class="form-control" v-model="variation.code" placeholder="Код">
                                                        </div>
                                                        <div class="col-12 col-md-6 widget">
                                                            <input type="text" class="form-control" v-model="variation.label" placeholder="Название">
                                                        </div>
                                                        <div class="col-12 col-md-6 widget">
                                                            <input type="text" class="form-control" v-model="variation.defaultValue"
                                                                   placeholder="Значение по умолчанию" v-if="variation.type === 'text'"/>
                                                            <numeric-input v-model="variation.defaultValue" placeholder="Значение по умолчанию" v-if="variation.type === 'integer'"></numeric-input>
                                                            <numeric-input v-model="variation.defaultValue" placeholder="Значение по умолчанию" v-if="variation.type === 'decimal'" :precision="2"></numeric-input>

                                                            <div class="row" v-if="variation.type === 'list' || variation.type === 'multiselect' || variation.type === 'multicheck'">
                                                                <div class="col-9">
                                                                    <select class="form-control" v-model="variation.defaultValue"
                                                                            :style="{color: (variation.defaultValue==='' ? '#CCCCCC' : '#000000')}">
                                                                        <option value="" style="color: #CCCCCC">Значение по умолчанию</option>
                                                                        <option :value="item.code" style="color: #000000" v-for="item in variation.items" :key="item.code">{{item.name}}</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-3">
                                                                    <button class="btn btn-info float-right" @click="showModalItems(index, variation)">Опции</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-md-6 widget">
                                                            <input type="text" class="form-control" v-model="variation.labelRu" placeholder="Название(RU)">
                                                        </div>
                                                        <div class="col-12 col-md-3 widget">
                                                            <div class="form-check">
                                                                <label class="form-check-label">
                                                                    <input class="form-check-input" type="checkbox" v-model="variation.required">
                                                                    <span class="form-check-sign"></span>
                                                                    Обязательный
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-md-3 widget">
                                                            <div class="form-check">
                                                                <label class="form-check-label">
                                                                    <input class="form-check-input" type="checkbox" v-model="variation.filterable">
                                                                    <span class="form-check-sign"></span>
                                                                    Фильтрующийся
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-right" slot="footer">
                                                    <button class="btn btn-info float-right pl-3 pr-3" @click="addVariation">+</button>
                                                </div>
                                            </draggable>
                                            <CategoryParamOptionsModal @apply="onParamOptionsApply"></CategoryParamOptionsModal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-default" @click="cancel" :disabled="processing">Отменить</button>
                                <button class="btn btn-success ml-3" @click="save" :disabled="processing">Сохранить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {BASE_API} from './../../axios'
    import {required/*, minLength, maxLength*/} from 'vuelidate/lib/validators';
    import CategoryParamOptionsModal from './CategoryParamOptionsModal';

    export default {
        name: "CategoryEdit",
        components: {
            CategoryParamOptionsModal: CategoryParamOptionsModal
        },
        data() {
            return {
                processing: false,
                category: {
                    id: null,
                    name: '',
                    nameRu: '',
                    sortOrder: null,
                    parent: null,
                    photo: null,
                    parameters: []
                },
                parents: [],
                dropZoneOptions: {
                    url: BASE_API + 'upload/category',
                    maxFiles: 1,
                    resizeWidth: 250,
                    acceptedFiles: 'image/*',
                    addRemoveLinks: true,
                    headers: { 'Authorization': `Bearer ` + localStorage.getItem('x_token')}
                }
            }
        },
        validations: {
            category: {
                name: {
                    required: required
                },
                nameRu: {
                    required: required
                }
            }
        },
        methods: {
            removeVariation(index) {
                this.category.parameters.splice(index, 1);
            },
            showModalItems(index, data) {
                this.$eventBus.$emit('modalParamOptions', {
                    index: index,
                    items: data.items
                });
            },
            onParamOptionsApply(data) {
                this.category.parameters[data.index].items = data.items;
            },
            addVariation() {
                this.category.parameters.push({
                    index: this.category.parameters.length + 1,
                    type: '',
                    code: '',
                    label: '',
                    labelRu: '',
                    defaultValue: '',
                    required: false,
                    filterable: false,
                    items: []
                });
            },
            cancel() {
                this.$router.push('/category');
            },
            load(id) {
                this.$http.get('category/' + id)
                    .then(res => {
                        res = res.data;
                        const variations = [];
                        if (res.variations 
                            && res.variations.fields && res.variations.fields.length > 0
                            && res.variations.data) {
                            res.variations.fields.forEach((key) => {
                                const variation = res.variations.data[key];
                                variation.code = key;
                                if (variation.type === 'integer' || variation.type === 'decimal') {
                                    variation.defaultValue = parseFloat(variation.defaultValue);
                                }
                                variations.push(variation);
                            });
                        }
                        res.parameters = variations;
                        this.category = res;
                        this.initPhotos();
                        if (this.category.parameters.length === 0) {
                            this.addVariation();
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                const variations = {
                    fields: [],
                    data: {}
                };
                this.category.parameters.forEach((param) => {
                    if (param.type && param.type.length > 0 && param.code && param.code.length > 0) {
                        const paramCode = param.code.replace(/[^a-zA-Z0-9_]/g, "");
                        variations.fields.push(paramCode);
                        variations.data[paramCode] = param;
                    }
                });
                this.category.variations = variations;
                this.$http.post('category', this.category)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push('/category');
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            initPhotos() {
                if (this.category && this.category.photo && this.category.photo.id
                    && this.$refs && this.$refs.categoryPhotoDropZone) {
                    this.$refs.categoryPhotoDropZone.manuallyAddFile(this.category.photo, this.category.photo.url);
                }
            },
            onParentSearch(searchTxt, loading) {
                loading(true);
                const excluded = [];
                if (this.category.id && this.category.id > 0) {
                    excluded.push(this.category.id);
                }
                this.$http.post('category/choose', {excludedIds: excluded, search: searchTxt})
                    .then(res => {
                        this.parents = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onParentFocus: function () {
                const excluded = [];
                if (this.category.id && this.category.id > 0) {
                    excluded.push(this.category.id);
                }
                this.$http.post('category/choose', {excludedIds: excluded, search: ''})
                    .then(res => {
                        this.parents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onDropZoneProgress(file, progress, bytesSent) {
                this.processing = true;
                console.log('dz-progress:' + progress + ':' + bytesSent);
            },
            onDropZoneSuccess(file, response) {
                this.processing = false;
                this.category.photo = response;
                console.log('dz-success');
                console.log(response);
            },
            onDropZoneRemove(/*file, error, xhr*/) {
                this.category.photo = null;
                console.log('dz-remove');
            },
            onDropZoneError() {
                this.processing = false;
                console.log('dz-error');
            }
        },
        created() {
            const id = this.$route.params.id;
            if (id && id > 0) {
                this.load(id);
            } else {
                this.addVariation();
            }
        }
    }
</script>

<style>
    .item {
        position: relative;
        margin-bottom: 30px;
        padding: 0 !important;
        border-bottom: 1px dashed #CCCCCC;
    }
    .item .btn-remove {
        color:red;
        cursor:pointer;
        position:absolute;
        right:0;
        top:-25px;
        z-index: 1000;
    }
    .item .widget {
        margin-bottom: 15px;
    }
    .item .form-check {
        padding-left: 0;
    }
</style>